import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "m-switchList" }
const _hoisted_2 = { class: "m-switchList__itemHead" }
const _hoisted_3 = {
  key: 0,
  class: "m-switchList__itemBody"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "m-switchList -is-condensed-list"
}
const _hoisted_6 = { class: "m-switchList__itemHead" }
const _hoisted_7 = { class: "m-formGroup -fullwidth" }
const _hoisted_8 = {
  key: 1,
  class: "m-switchList -is-condensed-list"
}
const _hoisted_9 = { class: "m-switchList__itemHead" }
const _hoisted_10 = {
  key: 0,
  class: "m-switchList -is-condensed-list"
}
const _hoisted_11 = { class: "m-switchList__itemHead" }
const _hoisted_12 = { class: "m-formGroup m-formGroup--selectAndSearch" }
const _hoisted_13 = {
  key: 1,
  class: "m-switchList -is-condensed-list"
}
const _hoisted_14 = { class: "m-switchList__itemHead" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BlockNotice = _resolveComponent("BlockNotice")!
  const _component_PanelRow = _resolveComponent("PanelRow")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_FormGroup = _resolveComponent("FormGroup")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_IconNotice = _resolveComponent("IconNotice")!
  const _component_Separator = _resolveComponent("Separator")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.controller.state.authenticationError || _ctx.controller.state.automaticSubscriptionNotice.state)
      ? (_openBlock(), _createBlock(_component_Panel, {
          key: 0,
          state: { hasNoHeader: true, isContentShown: true }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PanelRow, { state: {} }, {
              default: _withCtx(() => [
                (_ctx.controller.state.authenticationError)
                  ? (_openBlock(), _createBlock(_component_BlockNotice, {
                      key: 0,
                      type: _ctx.NoticeType.Error,
                      title: { key: _ctx.Translation.General_request_error_title },
                      content: { key: _ctx.Translation.Interest_subscription_authentication_error }
                    }, null, 8, ["type", "title", "content"]))
                  : _createCommentVNode("", true),
                (!_ctx.controller.state.authenticationError && _ctx.controller.state.automaticSubscriptionNotice.state)
                  ? (_openBlock(), _createBlock(_component_BlockNotice, {
                      key: 1,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.controller.handleAutomaticSubscriptionNoticeInteraction())),
                      type: _ctx.controller.state.automaticSubscriptionNotice.type,
                      title: _ctx.controller.state.automaticSubscriptionNotice.title,
                      content: _ctx.controller.state.automaticSubscriptionNotice.content
                    }, null, 8, ["type", "title", "content"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.controller.state.authenticationError)
      ? (_openBlock(), _createBlock(_component_Panel, {
          key: 1,
          state: { hasNoHeader: true, isContentShown: true }
        }, {
          default: _withCtx(() => [
            (!_ctx.controller.state.existingUser)
              ? (_openBlock(), _createBlock(_component_PanelRow, {
                  key: 0,
                  state: {}
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("h3", null, null, 512), [
                      [_directive_translate, { key: _ctx.Translation.User_enter_your_email }]
                    ]),
                    _withDirectives(_createElementVNode("p", null, null, 512), [
                      [_directive_translate, { key: _ctx.Translation.Interest_subscription_general_interest_description }]
                    ]),
                    _createVNode(_component_FormGroup, {
                      config: _ctx.FormConfigurationProvider.emailConfig,
                      state: _ctx.controller.state.email,
                      onStateChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.controller.updateStateEmail($event)))
                    }, null, 8, ["config", "state"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_PanelRow, {
              state: { hasNoBorder: true, hasPaddedContent: true },
              class: "-is-split-row"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("h3", null, null, 512), [
                  [_directive_translate, { key: _ctx.Translation.Interest_subscription_general_interest_section_title }]
                ]),
                _withDirectives(_createElementVNode("p", null, null, 512), [
                  [_directive_translate, { key: _ctx.Translation.Interest_subscription_general_interest_section_description }]
                ]),
                _createElementVNode("ol", _hoisted_1, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controller.state.eventimInterests, (interest) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: interest.resourceId,
                      class: "m-switchList__item"
                    }, [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("h4", null, _toDisplayString(interest.title), 1),
                        _createVNode(_component_Switch, {
                          state: { state: interest.state, type: _ctx.SwitchType.Basic },
                          onStateChange: ($event: any) => (_ctx.controller.handleInterestChange(interest, $event))
                        }, null, 8, ["state", "onStateChange"])
                      ]),
                      (interest.description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("p", null, _toDisplayString(interest.description), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_PanelRow, {
              state: { hasNoBorder: true, hasNoPadding: true },
              class: "-is-split-row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconNotice, {
                  state: { icon: _ctx.IconName.Gdpr, type: _ctx.IconNoticeType.Basic, hasSwitch: false }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", {
                      innerHTML: _ctx.controller.getDppNotice()
                    }, null, 8, _hoisted_4)
                  ]),
                  _: 1
                }, 8, ["state"])
              ]),
              _: 1
            }),
            _createVNode(_component_PanelRow, { state: {} }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("h3", null, null, 512), [
                  [_directive_translate, { key: _ctx.Translation.Interest_subscription_artist_section_title}]
                ]),
                _withDirectives(_createElementVNode("p", null, null, 512), [
                  [_directive_translate, { key: _ctx.Translation.Interest_subscription_artist_section_description }]
                ]),
                (_ctx.controller.state.artistInterests.length)
                  ? (_openBlock(), _createElementBlock("ol", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controller.state.artistInterests, (interest) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: interest.resourceId,
                          class: "m-switchList__item"
                        }, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("h4", null, _toDisplayString(interest.title), 1),
                            _createVNode(_component_Switch, {
                              state: { state: interest.state, type: _ctx.SwitchType.Basic },
                              onStateChange: ($event: any) => (_ctx.controller.handleInterestChange(interest, $event))
                            }, null, 8, ["state", "onStateChange"])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Separator, {
                  label: _ctx.controller.translations?.artistSeparatorLabel
                }, null, 8, ["label"]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_TextField, {
                    config: { label: _ctx.controller.translations?.searchByName, name: 'artistAlarmQuery', fullwidth: true },
                    state: _ctx.controller.state.artistInterestQuery.name,
                    onStateChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.controller.updateArtistAlarmQuery($event)))
                  }, null, 8, ["config", "state"])
                ]),
                (_ctx.controller.getArtistAlarmResults().length)
                  ? (_openBlock(), _createElementBlock("ol", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controller.getArtistAlarmResults(), (interest) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: interest.resourceId,
                          class: "m-switchList__item"
                        }, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("h4", null, _toDisplayString(interest.title), 1),
                            _createVNode(_component_Switch, {
                              state: { state: interest.state, type: _ctx.SwitchType.Basic },
                              onStateChange: ($event: any) => (_ctx.controller.handleInterestChange(interest, $event))
                            }, null, 8, ["state", "onStateChange"])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_PanelRow, { state: {} }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("h3", null, null, 512), [
                  [_directive_translate, { key: _ctx.Translation.Interest_subscription_topics_section_title }]
                ]),
                _withDirectives(_createElementVNode("p", null, null, 512), [
                  [_directive_translate, { key: _ctx.Translation.Interest_subscription_topics_section_description }]
                ]),
                (_ctx.controller.state.topicInterests.length)
                  ? (_openBlock(), _createElementBlock("ol", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controller.state.topicInterests, (interest) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: interest.resourceId,
                          class: "m-switchList__item"
                        }, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("h4", null, _toDisplayString(interest.title), 1),
                            _createVNode(_component_Switch, {
                              state: { state: interest.state, type: _ctx.SwitchType.Basic },
                              onStateChange: ($event: any) => (_ctx.controller.handleInterestChange(interest, $event))
                            }, null, 8, ["state", "onStateChange"])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Separator, {
                  label: _ctx.controller.translations?.interestSeparatorLabel
                }, null, 8, ["label"]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_Multiselect, {
                    modelValue: _ctx.interestType,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.interestType) = $event)),
                    placeholder: _ctx.controller.translations?.interestTypeSelectionLabel,
                    options: _ctx.InterestManagementFactory.interestTypeOptions(),
                    object: true,
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.controller.handleInterestTypeChange($event)))
                  }, null, 8, ["modelValue", "placeholder", "options"]),
                  _createVNode(_component_TextField, {
                    config: {
                        label: _ctx.controller.translations?.limitByName,
                        name: 'interestQuery',
                    },
                    state: _ctx.controller.state.topicInterestQuery.name,
                    onStateChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.controller.updateInterestQuery($event)))
                  }, null, 8, ["config", "state"])
                ]),
                (_ctx.controller.getInterestResults().length)
                  ? (_openBlock(), _createElementBlock("ol", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controller.getInterestResults(), (interest) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: interest.resourceId,
                          class: "m-switchList__item"
                        }, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("h4", null, _toDisplayString(interest.title), 1),
                            _createVNode(_component_Switch, {
                              state: { state: interest.state, type: _ctx.SwitchType.Basic },
                              onStateChange: ($event: any) => (_ctx.controller.handleInterestChange(interest, $event))
                            }, null, 8, ["state", "onStateChange"])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.controller.state.existingUser)
              ? (_openBlock(), _createBlock(_component_PanelRow, {
                  key: 1,
                  state: {}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconNotice, {
                      state: {
                    icon: _ctx.IconName.BellOff,
                    type: _ctx.IconNoticeType.Error,
                    hasSwitch: true,
                    switchState: {
                        state: _ctx.controller.state.noContactInterest.state,
                        type: _ctx.SwitchType.Error,
                    }
                },
                      onStateChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.controller.handleNoContactChange(_ctx.controller.state.noContactInterest, $event)))
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("h4", null, null, 512), [
                          [_directive_translate, { key: _ctx.Translation.Customer_no_contact_title }]
                        ]),
                        _withDirectives(_createElementVNode("p", null, null, 512), [
                          [_directive_translate, { key: _ctx.Translation.Customer_no_contact_description }]
                        ])
                      ]),
                      _: 1
                    }, 8, ["state"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_PanelRow, { state: {} }, {
              default: _withCtx(() => [
                (_ctx.controller.state.notice.state)
                  ? (_openBlock(), _createBlock(_component_BlockNotice, {
                      key: 0,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.controller.handleNoticeInteraction())),
                      title: _ctx.controller.state.notice.title,
                      content: _ctx.controller.state.notice.content
                    }, null, 8, ["title", "content"]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.controller.createSubscription()), ["stop"])),
                  class: _normalizeClass(["a-button -submit", [{ '-active': _ctx.controller.hasValidSubscription(_ctx.controller.state) }]]),
                  type: "submit",
                  disabled: !_ctx.controller.hasValidSubscription(_ctx.controller.state)
                }, [
                  (!_ctx.controller.state.existingUser)
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_16, null, 512)), [
                        [_directive_translate, { key: _ctx.Translation.Notifications_subscribe }]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.controller.state.existingUser)
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_17, null, 512)), [
                        [_directive_translate, { key: _ctx.Translation.Save }]
                      ])
                    : _createCommentVNode("", true)
                ], 10, _hoisted_15)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}